import {RoutesReportControlRequest, TypeRequestReportRouteEnum} from './types';
import {CONFIG} from '@/config';
import {ServiceHelper} from '@/utils/service.helper';

const baseUrl = `${CONFIG.URL.NEOGIG_API}/DistanceReport`;

export class NearestReportService {
  public static listAllRequestsByType = (type: TypeRequestReportRouteEnum): Promise<RoutesReportControlRequest[]> =>
      ServiceHelper.mapToPromise<RoutesReportControlRequest[]>(`${baseUrl}/ListRequestsByType?type=${type}`);

  public static getReportStoreToStores = (idStore: number, nameStore: string): Promise<void> =>
      ServiceHelper.generateFile(`${baseUrl}/ClosestStoresFromStore/${idStore}`,
          `Nearest stores from ${nameStore}.xlsx`,
      );

  public static getReportStoreToOperationalAreas = (idStore: number, nameStore: string): Promise<void> =>
      ServiceHelper.generateFile(`${baseUrl}/ClosestOperationAreasFromStore/${idStore}`,
          `Nearest operational areas from ${nameStore}.xlsx`,
      );

  public static getReportCityToStores = (idCity: number, nameCity: string): Promise<void> =>
      ServiceHelper.generateFile(`${baseUrl}/ClosestStoresFromLocation/${idCity}`,
          `Nearest store from ${nameCity}.xlsx`,
      );

  public static getReportCityToOperationalAreas = (idCity: number, nameCity: string): Promise<void> =>
      ServiceHelper.generateFile(`${baseUrl}/ClosestOperationAreasFromLocation/${idCity}`,
          `Nearest operational areas from ${nameCity}.xlsx`,
      );
}
